import 'apps/personal/styles/components/survey-cta.scss';
import 'library/styles/pages/base-page.scss';
import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import Helmet from 'react-helmet';
import Cache from 'library/util/cache';

const SurveyCTA = ({ url }) => (
  <Fragment>
    <Helmet>
      <body className="personal-application survey-cta" />
    </Helmet>
    <div className="full-page full-page-auxilary-3 survey-cta">
      <div className="survey-cta-inner">
        <h1>Welcome</h1>
        <h3>Looks like you haven’t taken your survey yet!</h3>
        <a href={url} onClick={()=>Cache.clear('graph_data')} target="_blank" className="button">TAKE ME TO MY SURVEY</a>
        <p>The PAIRIN survey is a vital part of the pairin application. We use it to show personalized curriculum and information, without it your personal page would just be blank.</p>
      </div>
    </div>
  </Fragment>
);

SurveyCTA.propTypes = {
  url: PropTypes.string.isRequired
};

export default SurveyCTA;
